import React from 'react';
import useDfpSlot from './useDfpSlot'

const AdUnit = () => {
    useDfpSlot({
        path: '/4218/rollcall/MemberGuideMidHorizontal',
        size: [[320, 50], [970, 90], [300, 250], [970, 500], [300, 50], [940, 470], 'fluid', [970, 250], [1160, 250], [1160, 400], [1, 1], [320, 150]],
        id: 'div-gpt-ad-1597337035409-0',
    });
	return (
        <div style={{margin: '0 auto', textAlign:'center'}}>
            <div id="div-gpt-ad-1597337035409-0"/>
        </div>
	);
}

export default AdUnit;
